import { useMemo } from 'react';
import {
  parseDependentFieldId,
  isCRMAccountSearcherDependentField
} from 'src/components/CustomFields/CRM/CRMFieldUtils';
import { CustomFieldDefinition } from '@alucio/aws-beacon-amplify/src/models';
import { useComposableForm } from 'src/components/CustomFields/ComposableForm';

export const useIsCRMDependentChildField = (field: CustomFieldDefinition): boolean => {
  const { customFields } = useComposableForm();

  const parsedDependency = useMemo(
    () => {
      if (!field.dependentFieldId) return null;
      return parseDependentFieldId(field.dependentFieldId);
    },
    [field.dependentFieldId]
  );

  const parentField = useMemo(
    () => {
      if (!parsedDependency) return undefined;
      return customFields.find((cf) => cf.id === parsedDependency.parentFieldId);
    },
    [parsedDependency, customFields]
  );

  const isCRMDepedentChildField = useMemo(
    () => {
      return isCRMAccountSearcherDependentField(field, parentField);
    },
    [field, parentField]
  );

  return isCRMDepedentChildField
}

export default useIsCRMDependentChildField